import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Card, CardContent,TextField, CardActions,CardHeader} from '@material-ui/core';
import {Typography,Button,Grid} from '@material-ui/core';
import './neworder.css';

const useStyles = makeStyles({
    root:{
        minWidth: 275,
        backgroundColor: "primary",
    },
    title:{
        fontSize: 14,
    }
})

const NewOrder = (props) => {
    const classes = useStyles()
    //const socket = props.socket;
    const [description, setDescription] = useState("")

    const handleChange = (e) =>{
        setDescription(e.target.value)
    }

    const addOrder = (e) =>{
        console.log(description);
        setDescription("");
        //Need to somehow call this on parent component
        props.addNewOrder(description)
        //socket.emit("add_new_order",description);
    }
    
    return (
        <div>
            <Button variant = "contained" color = "primary" onClick={addOrder}>New Order Ready</Button>
            <TextField id="outlined-basic" value={description} fullWidth="true"  label="Description (Optional)" variant="outlined" onChange = {handleChange}/>  
        </div>
        
    )
}

export default NewOrder;